// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1075":"70949c9f","2940":"9af36644","8543":"9af36644"}[chunkId] + ".chunk.css";
};